import myModal from '@/components/common/modal/index.vue'
// import steamLogin from './steamLogin.vue'
import index from './index.vue';
import scroll from '@/utils/noscroll.js';
// i18n
import i18n from '@/i18n/'
import router from '@/router'

import { render, h, createApp } from "vue";
export const signupModal = (params, callback) => {
  console.log('params:', params);
  //使用vue方式创建组件
  const div = document.createElement('div')
  document.body.appendChild(div)
  const app = createApp(index, {
    visible: params.visible,
    title: params.title,
    inviteType:params.inviteType,
    contentType: params.contentType,
    // 2026-10-14 主播弹窗配置化：原先只透传上面 4 个 prop，
    // 导致后台配置的文案/图片根本没进组件（组件只能走 legacy 硬编码文案）。
    anchorTitle:    params.anchorTitle === undefined ? null : params.anchorTitle,
    anchorLine1:    params.anchorLine1 === undefined ? null : params.anchorLine1,
    anchorLine2:    params.anchorLine2 === undefined ? null : params.anchorLine2,
    bonusAmount:    params.bonusAmount,
    promoCode:      params.promoCode      || "",
    depositPercent: params.depositPercent,
    promoImage:     params.promoImage     || "",
    badgeImage:     params.badgeImage     || "",
    /**
     * 事件监听 触发冲突,要么不监听onclick 直接监听自定义事件,要么给事件添加stopPropagation  阻止事件冒泡
     */
    onClick: () => {
      //点一个复选框 会监听到调用两次 why?
      // console.log('js in onclick');
    },
    onLogin: () => {
      // console.log('response login result');
    },
    onEmail: (val) => {
      console.log('onemail', val);
      callback(() => {
        console.log('c:', val);
      })
    },

    onClose: () => {
      console.log('登录成功或关闭登录');

      //销毁该组件实例
      app.unmount()
      div.remove()

      callback(() => {
        //登录成功或取消登录,更新用户数据
        console.log('pass callback');
      })
    }
  })
  app.provide('scroll', scroll)
  app.component('myModal', myModal)
  app.use(i18n)
  app.use(router)
  app.mount(div)//挂载

  router.beforeEach((to, from, next) => {
    next();
    app._props.onClose()
    // console.log('app;',app._props.onClose());

  });
}